<template>
  <div class="base-button-medium-orange">
    <button type="button" :disabled="disabled" @click="handleClick">
      <span><slot /></span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'BaseButtonMediumOrange',

  props: {
    disabled: { type: Boolean, default: false }
  },

  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.base-button-medium-orange {
  > button {
    height: 44px;
    width: 200px;
    border-radius: 6px;
    background-color: #{$plus_orange};
    cursor: pointer;
    border: none;
    color: #{$plus_white};
    &:disabled {
      pointer-events: none;
      background-color: #{$plus_white};
      color: #{$plus_7c_gray};
    }
    &:hover {
      opacity: 0.8;
    }
    &:active {
      margin: 2px auto 0 auto;
      height: 42px;
    }
    > span {
      height: 29px;
      font-size: 15px;
      font-weight: bold;
      line-height: 1.45;
    }
  }
}
</style>
